// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"135":"50ee8fad","299":"59bf7955","565":"0ccb3f8a","574":"effce7a7","799":"d53e4242","821":"ac639fa6"}[chunkId] + ".css";
};